import styled from "styled-components";

export const VectorWrapperDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
